import React,{useState} from 'react';
import { Link } from 'react-router-dom';
import Menu from '../icons/Menu';
import Tabmenu from './tabmenu/Tabmenu';
export default function Medication() {
  let  [chat,setChat]= useState('');
  let [medicine,setMedicine] = useState('');
  let [dosage,setDosage] = useState(0);
  let [dosageduration,setDosageduration] = useState('');
  let [dostime,setDostime] = useState('');
  let [next,setnext] = useState('');
  return (
    <>
      <div className=" bg-gray-50 h-screen overflow-scroll">
        <div className='flex text-black p-4 pt-6 h-16 fixed max-w  z-50 w-full bg-gray-50 '>
          <div>
          <Link to="/Dashboard">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
            </svg>
            </Link>
          </div>
          <div className='pl-2 flex-1 mt-0.5'>
            <h4 className='font-semibold text-sm'>Medication</h4>
          </div>

          <Link to="/AddMedication" className="text-white bg-primary px-2 rounded-xl text-xs -mt-1 h-9 p-2.5">
            <span className='border-2 border-white px-1 pt-0 pb-0.5 rounded-lg text-md'>+</span>&nbsp; Add Medication
          </Link>
        </div>
        <div className='h-20'></div>
        <div className=' justify-between p-4 grid grid-cols-1 gap-4'>
          <div className='bg-gray-200 flex rounded-xl pr-2 pb-2 p-4'>
            <img src="../../../images/capsules.png" className="h-8 m-3"/>
            <div className='flex-1  mb-6'>
                <div className='font-semibold'>Fexofenadine HCL tablet...</div>
                <div>Take 1 pill for 2 weeks</div>
            </div>
            <div className='relative'>
                <button className='absolute bottom-0 right-0 bg-white rounded-2xl px-3 py-1 text-xs font-semibold flex'> 
                <div className='bg-green-500 h-2 w-2 mt-1 mr-1 rounded-full'></div>
                Active
                </button>
            </div>
          </div>
          <div className='bg-gray-200 flex rounded-xl pr-2 pb-2 p-4'>
            <img src="../../../images/capsules.png" className="h-8 m-3"/>
            <div className='flex-1  mb-6'>
                <div className='font-semibold'>Fexofenadine HCL tablet...</div>
                <div>Take 1 pill for 2 weeks</div>
            </div>
            <div className='relative'>
                <button className='absolute bottom-0 right-0 bg-white rounded-2xl px-3 py-1 text-xs font-semibold flex'> 
                <div className='bg-green-500 h-2 w-2 mt-1 mr-1 rounded-full'></div>
                Active
                </button>
            </div>
          </div>
          <div className='bg-gray-200 flex rounded-xl pr-2 pb-2 p-4'>
            <img src="../../../images/capsules.png" className="h-8 m-3"/>
            <div className='flex-1 mb-6'>
                <div className='font-semibold'>Fexofenadine HCL tablet...</div>
                <div>Take 1 pill for 2 weeks</div>
            </div>
            <div className='relative'>
                <button className='absolute bottom-0 right-0 bg-white rounded-2xl px-3 py-1 text-xs font-semibold flex'> 
                <div className='bg-green-500 h-2 w-2 mt-1 mr-1 rounded-full'></div>
                Active
                </button>
            </div>
          </div>
          <div className='bg-gray-200 flex rounded-xl pr-2 pb-2 p-4'>
            <img src="../../../images/capsules.png" className="h-8 m-3"/>
            <div className='flex-1  mb-6'>
                <div className='font-semibold'>Fexofenadine HCL tablet...</div>
                <div>Take 1 pill for 2 weeks</div>
            </div>
            <div className='relative'>
                <button className='absolute bottom-0 right-0 bg-white rounded-2xl px-3 py-1 text-xs font-semibold flex'> 
                <div className='bg-green-500 h-2 w-2 mt-1 mr-1 rounded-full'></div>
                Active
                </button>
            </div>
          </div>
        </div>
      </div>





     
      <div className='h-16'></div>
      <Tabmenu />
    </>
  );
}